import { render } from "./InputMany.vue?vue&type=template&id=5d908a84&scoped=true"
import script from "./InputMany.vue?vue&type=script&lang=js"
export * from "./InputMany.vue?vue&type=script&lang=js"

import "./InputMany.vue?vue&type=style&index=0&id=5d908a84&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d908a84"]])

export default __exports__